import LoanInfoIcon from "../assets/images/icons/loanInfo.gif";
import StatementIcon from "../assets/images/icons/payment.gif";
import CalculatorIcon from "../assets/images/icons/calculator.gif";
import FaqIcon from "../assets/images/icons/faq.gif";
import CalenderIcon from "../assets/images/icons/calendar.gif";
import ProductIcon from "../assets/images/icons/product.svg";
import LoanIcon from "../assets/images/icons/loanInfonew.gif";
import Profile from "../assets/images/icons/profile.gif";
import OtherIcon from "../assets/images/icons/otherIcon.gif";
import ReferralWebImage from "../assets/images/referral-banner/Referral-Web.png";
import ReferralWebMiniImage from "../assets/images/referral-banner/Referral-Web-mini.jpeg";
import ReferralWebPWAImage from "../assets/images/referral-banner/Referral-Web-PWA.jpeg";
import AWS_Web_Banner_1 from "../assets/aws/AWS_Web_Banner_1.jpg";
import AWS_Web_Banner_2 from "../assets/aws/AWS_Web_Banner_2.jpg";
import AWS_Web_Banner_3 from "../assets/aws/AWS_Web_Banner_3.jpg";
import AWS_MOBILE_Banner from "../assets/aws/AWS_MOBILE_Banner.jpeg";

const constVariable = {
  App_title: "Flexi Customer Portal",
};

const messages = {
  noPermission: {
    module: "You don't have access to",
    section: "You don't have access to make",
    action: "You don't have access to",
  },
  withdrErrorMessages: {
    overdue:
      "Please settle your overdue amount before raising a disbursement request.",
    commonError: "An error occurred",
    enterAmountError: "The entered amount is grater than available limit.",
    otpVerify:
      "Withdrawal Request is successfully captured. We will update you once request is processed",
  },
  paymentErrorMessages: {
    timeout: "Timeout waiting for API response",
    inProgress:
      "Final status of your transaction is awaited. Please check the latest status in transaction history.",
    partPayment:
      "Part Payment is not allowed if Principal Outstanding Amount is less than or equal to Rs.2",
    partPayment2: "The entered amount should be less than or equal to",
    overdue: "The entered amount is more than Over Due Amount",
  },
};

const filterOptionsWithdraw = [
  { label: "All", value: "all" },
  { label: "Pending", value: "pending" },
  { label: "Approved", value: "approve" },
  { label: "Rejected", value: "reject" },
];
const filterOptionsPay = [
  { label: "All", value: "all" },
  { label: "In progress", value: "inprogress" },
  { label: "Failed", value: "failed" },
  { label: "Link Expired", value: "linkexpired" },
  { label: "Success", value: "success" },
];
const filterOptionsPartPay = [
  { label: "All", value: "all" },
  { label: "Open", value: "Open" },
  { label: "Closed", value: "Closed" },
  { label: "Expired", value: "Expired" },
  { label: "Cancelled", value: "Cancelled" },
];
const filterOptionsDisbursement = [
  { label: "All", value: "all" },
  { label: "Approved", value: "approve" },
  { label: "Partially Approved", value: "partiallyApproved" },
  { label: "Pending", value: "AvanseApprovalPending" },
  { label: "Indraft", value: "indraft" },
  { label: "Rejected", value: "reject" },
  { label: "Query", value: "query" },
  { label: "Cancelled", value: "cancelled" },
];
const documentsItOptions = {
  certificate: [
    {
      label: "Get Provisional Interest Certificate",
      value: "provsonintstcert",
    },
    { label: "Get Interest Certificate", value: "instcert" },
  ],
  years: [
    { label: "FY22-23", value: "2022" },
    { label: "FY23-24", value: "2023" },
  ],
  payment_secret_key: "A745F72A4230A1CBF4D93EA702687567",
};
const maxFileSize = 10000000;
const paymentLimit = 900000;
const quickLinks = [
  { title: "Loan Account Info", icon: LoanIcon },
  { title: "Account Statements", icon: LoanInfoIcon },
  { title: "Repayment Schedule", icon: Profile },
  { title: "Fund request", icon: OtherIcon },
  { title: "Payment", icon: StatementIcon },
  { title: "FAQ", icon: FaqIcon },
];
const faqUrl = "https://www.avanse.com/faqs";
const salesFaqUrl = "https://www.avanse.com/sli-faq-customer";
const applyNow = "https://www.avanse.com/apply-now?source=Header";

const referralLinkMap: { [key: number]: string } = {
  0: "https://www.avanse.com/referral-program?source=SocialMedia&campaignid=Referral_Dashboard",
  1: "https://www.avanse.com/referral-program?source=SocialMedia&campaignid=Referral_FundRequest",
  2: "https://www.avanse.com/referral-program?source=SocialMedia&campaignid=Referral_Payment",
  3: "https://www.avanse.com/referral-program?source=SocialMedia&campaignid=Referral_Documents",
  4: "https://www.avanse.com/referral-program?source=SocialMedia&campaignid=Referral_History",
};

const referralImageMap: { [key: number]: { web: string } } = {
  0: { web: ReferralWebImage },
  1: { web: ReferralWebMiniImage },
  2: { web: ReferralWebMiniImage },
  3: { web: ReferralWebMiniImage },
  4: { web: ReferralWebMiniImage },
};

const referralBannerCarousel = (val: boolean) => {
  if(val) {
    return [
      {
        image: ReferralWebPWAImage,
        link: referralLinkMap[0],
      },
    ]
  }
  return [
    {
      image: ReferralWebPWAImage,
      link: referralLinkMap[0],
    },
    {
      image: AWS_MOBILE_Banner,
      link: "",
    },
  ]
};

const awsReferralBannerDesktop = [
  {
    image: AWS_Web_Banner_1,
  },
  {
    image: AWS_Web_Banner_2,
  },
  {
    image: AWS_Web_Banner_3,
  },
];

const iconsAndTitles = [
  { icon: ProductIcon, title: "Product 1" },
  { icon: ProductIcon, title: "Product 1" },
  { icon: ProductIcon, title: "Product 1" },
  { icon: ProductIcon, title: "Product 1" },
  { icon: ProductIcon, title: "Product 1" },
  { icon: ProductIcon, title: "Product 1" },
];
const disbReInfo = [
  {
    label:
      "Fund release requests that are successfully submitted will be processed within 48 hours.",
  },
  {
    label:
      "Once submitted, our team will conduct a thorough review of the request.",
  },
  {
    label:
      "If any discrepancies or missing details are identified, the request may be rejected, and you will be notified of the reason so you can take the necessary action.",
  },
];
const paymentInfo = [
  {
    label:
      "You can make Part Payment & Overdue payments using the Payment section.",
  },
  {
    label:
      "Part payment is not allowed if there is an existing overdue against the LAN account.",
      // "Part payment is not allowed if there is an existing overdue against the loan account, or during the active EMI processing window around your due date.",
  },
  {
    label:
      "In each part payment request, the minimum principal amount allowed to be cleared is 3 times the EMI and its maximum value is 50% of the principal outstanding.",
      // "For each part payment request, the minimum principal amount allowed to be cleared is 3 times the EMI and the maximum value is 50% of the principal outstanding.",
  },
  {
    label:
      "Applicable charges will be levied for Part payment & Overdue payments as per the policy.",
      // "Applicable charges will be levied for Part payment & Overdue payments as per the schedule of charges.",
    link: {
      text: "schedule of charges",
      url: "https://www.avanse.com/schedule-of-charges",
    },
  },
  {
    label:
      "For part payment requests, the Repayment Schedule is updated for the paid amount within 72 working hours after the request is submitted.",
      // "For part payment requests, the Repayment Schedule is updated for the paid amount within 72 working hours after payment is received.",
  },
];



const validStatuses = ["M", "C", "W", "E", "S"];

const withdrawInfo = [
  {
    label: "Successfully raised Withdrawal requests will be processed in 24 Hours",
  },
  {
    label:
      "Withdrawal request will be validated at Avanse end before taking it for processing. If there any concerns with respect to request, it will be rejected and reason will be informed to customer",
  },
  {
    label:
      "In case of Overdue, customer will have to clear it first and then only withdrawal request will be accepted",
  },
  {
    label:
      "OTP for withdrawal request will be received on registered mobile number of logged in customer",
  },
];

const flexiPaymentInfo = [
  {
    label:
      "Customer can make Part Payment and Overdue Payment from the Payment Section.",
  },
  {
    label:
      "Convience Fee will be applied to cover the cost of processing the transaction.",
  },
  {
    label:
      " If there is overdue on the account, customer needs to clear it first before going for Part Payment.",
  },
  {
    label:
      " Part Payment Fee will not be applied on the Part Payment.",
  },
  {
    label:
      "Payment for successful transactions will reflect in the account after 1 hour of transaction completion.",
  },
];

const currencyIcon = [
  {
    id: 3,
    currencyCode: "AED",
    currencyDescription: "Emirati Dirham",
    icon: "د.إ",
  },
  {
    id: 569,
    currencyCode: "AUD",
    currencyDescription: "Australian Dollar",
    icon: "$",
  },
  {
    id: 570,
    currencyCode: "BHD",
    currencyDescription: "Bahrain Dinar",
    icon: ".د.ب",
  },
  {
    id: 571,
    currencyCode: "CAD",
    currencyDescription: "Canadian Dollar",
    icon: "$",
  },
  {
    id: 572,
    currencyCode: "CHF",
    currencyDescription: "Swiss Franc",
    icon: "CHF",
  },
  {
    id: 573,
    currencyCode: "CNY",
    currencyDescription: "Chinese Yuan",
    icon: "¥",
  },
  {
    id: 574,
    currencyCode: "CZK",
    currencyDescription: "Czech Koruna",
    icon: "Kč",
  },
  {
    id: 575,
    currencyCode: "DKK",
    currencyDescription: "Danish Kroner",
    icon: "kr",
  },
  {
    id: 576,
    currencyCode: "EGP",
    currencyDescription: "Egyptian Pound",
    icon: "ج.م",
  },
  {
    id: 577,
    currencyCode: "EUR",
    currencyDescription: "Euro",
    icon: "€",
  },
  {
    id: 578,
    currencyCode: "GBP",
    currencyDescription: "Great Britain Pound",
    icon: "£",
  },
  {
    id: 579,
    currencyCode: "HKD",
    currencyDescription: "Hongkong Dollar",
    icon: "$",
  },
  {
    id: 580,
    currencyCode: "INR",
    currencyDescription: "Indian Rupee",
    icon: "₹",
  },
  {
    id: 581,
    currencyCode: "JOD",
    currencyDescription: "Jordan Dinar",
    icon: ".د.أ",
  },
  {
    id: 582,
    currencyCode: "JPY",
    currencyDescription: "Japanese Yen",
    icon: "¥",
  },
  {
    id: 583,
    currencyCode: "KWD",
    currencyDescription: "Kuwait Dinar",
    icon: ".د.ك",
  },
  {
    id: 584,
    currencyCode: "MYR",
    // Malaysian Ringgit icon is RM
    currencyDescription: "Malaysian Ringgit",
    icon: "RM",
  },
  {
    id: 585,
    currencyCode: "NOK",
    currencyDescription: "Norwegian Kroner",
    icon: "kr",
  },
  {
    id: 586,
    currencyCode: "NZD",
    currencyDescription: "New Zealand Dollar",
    icon: "$",
  },
  {
    id: 587,
    currencyCode: "OMR",
    currencyDescription: "Omani Rial",
    icon: "ر.ع.",
  },
  {
    id: 588,
    currencyCode: "PHP",
    currencyDescription: "Philippine Peso",
    icon: "₱",
  },
  {
    id: 589,
    currencyCode: "QAR",
    currencyDescription: "Qatar Rial",
    icon: "ر.ق.",
  },
  {
    id: 590,
    currencyCode: "RUB",
    currencyDescription: "Ruble",
    icon: "₽",
  },
  {
    id: 591,
    currencyCode: "SAR",
    currencyDescription: "Saudi Rial",
    icon: "ر.س.",
  },
  {
    id: 592,
    currencyCode: "SEK",
    currencyDescription: "Swedish Kroner",
    icon: "kr",
  },
  {
    id: 593,
    currencyCode: "SGD",
    currencyDescription: "Singapore Dollar",
    icon: "$",
  },
  {
    id: 594,
    currencyCode: "SYP",
    currencyDescription: "Syrian Pound",
    icon: "ل.س.",
  },
  {
    id: 595,
    currencyCode: "THB",
    currencyDescription: "Thai Baht",
    icon: "฿",
  },
  {
    id: 596,
    currencyCode: "TRY",
    currencyDescription: "Turkish Lira",
    icon: "₺",
  },
  {
    id: 597,
    currencyCode: "USD",
    currencyDescription: "US Dollar",
    icon: "$",
  },
  {
    id: 598,
    currencyCode: "ZAR",
    currencyDescription: "South African Rand",
    icon: "R",
  },
];

const paymentInstructions = [
  "Please ensure that the payment is made using all the generated payment links to complete the payment process for the entire amount.",
  " Multiple payment links are generated if the total payable amount exceeds ₹ 9 lakhs.",
  " The payment links will be activated in the same order as they appear on the customer portal. This will ensure that the total loan amount paid is aligned with the minimum allowed part payment amount, i.e., 3 times the EMI and the applicable charges.",
  " Each payment link will remain valid for 1 hour after being opened. If a payment fails, you are allowed up to 2 retry attempts.",
];
const overdueInstructions = [
  "Please ensure that the payment is made using all the generated payment links to complete the payment process for the entire amount.",
  "Multiple payment links are generated if the total payable amount exceeds ₹ 9 lakhs.",
  "Each payment link will remain valid for 1 hour after being opened. If a payment fails, you are allowed up to 2 retry attempts.",
];

const RelationWithStudentList = [
  "STUDENT",
  "Spouse",
  "Sister in law",
  "Sister (married)",
  "Private Limited Entities",
  "Paternal Uncle",
  "Paternal uncle",
  "Paternal Grandmother",
  "Paternal Grandfather",
  "Paternal Aunt",
  "Partnership firm",
  "OTHERS",
  "Mother in Law",
  "Mother",
  "Maternal Uncle",
  "Maternal uncle",
  "Maternal or Paternal Uncle or Aunt",
  "Maternal Grandmother",
  "Maternal Grandfather",
  "Maternal aunt",
  "Maternal Aunt",
  "Limited Liability Partnership",
  "Grandparents",
  "Grandmother",
  "Grandfather",
  "First cousin",
  "father in law",
  "Father",
  "Brother in law",
  "BROTHER"
]
export default constVariable;
export const TrackingId = process.env.REACT_APP_GA_TRACKING_ID || "";

export {
  paymentInstructions,
  overdueInstructions,
  documentsItOptions,
  filterOptionsWithdraw,
  filterOptionsPay,
  messages,
  filterOptionsDisbursement,
  quickLinks,
  iconsAndTitles,
  faqUrl,
  salesFaqUrl,
  applyNow,
  referralLinkMap,
  referralImageMap,
  referralBannerCarousel,
  disbReInfo,
  paymentInfo,
  filterOptionsPartPay,
  validStatuses,
  currencyIcon,
  maxFileSize,
  paymentLimit,
  withdrawInfo,
  flexiPaymentInfo,
  RelationWithStudentList,
  awsReferralBannerDesktop
};
export const anchorModalContentOne = 
`For relying upon KYC documents supplied to us, whether by you or through our representative/service provider, for meeting our legal, regulatory and compliance obligations such as customer due diligence, know your customer/re-KYC/anti-money laundering checks, processing your loan application details and other value-added services;

For providing your application details to Central KYC Registry, UIDAI, credit information companies/credit bureaus for verification purposes;

For verifying the applied (i) course or admission details with the institute/university, (ii) credentials with the relevant third parties required in respect of the loan application, (iii) enrollment verifications from organizations/entity in possession of such data;

For enabling repayment and ensuring recovery of amounts due from you including through our appointed recovery agents, etc.

For our general administration and granting services in relation to the above;

For contacting you over, Emails, WhatsApp, call and SMS, overriding NDNC registration.`
